import * as _ from 'lodash';
import { fromJS } from 'immutable';
import * as actions from '../../actions/equityFinder/property';
import { fetchingState, defaultPageSize } from '../../constants';

const initialStats = {
  option: {
    fields: [],
    searchOptions: {},
    searchRules: [],
  },
  propertyList: {
    pageSize: defaultPageSize,
    sortModel: [],
    filterModel: [],
    currentPage: 0,
  },
  property: {},
  protest: {},
  searchRule: {},
  searchField: '',
  searchOperator: '',
  compGrid: {},
  compPropertyList: {},
  propertyCategories: {},
  propertyCategory: {},
  valid: {},
  allPropertyFetchState: '',
  score: {},
  generatingComp: fetchingState.LOADED,
  generatingCover: fetchingState.LOADED,
  integrityCheckData: {},
};

export default (state = fromJS(initialStats), action) => {
  switch (action.type) {
    case actions.PROPERTY_FETCH_SEARCH_OPTIONS_SUCCESS:
      return state.setIn(
        ['option', 'searchOptions'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.PROPERTY_FETCH_SEARCH_RULES_SUCCESS:
      return state.setIn(
        ['option', 'searchRules'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.PROPERTY_FETCH_FIELDS_SUCCESS:
      return state.setIn(
        ['option', 'fields'],
        fromJS(action.data ? action.data.results : []),
      );

    case actions.PROPERTY_SEARCH_START:
      return state.setIn(['propertyList', 'state'], fetchingState.FETCHING);
    case actions.PROPERTY_SEARCH_SUCCESS:
      let newState = state.setIn(
        ['propertyList', 'state'],
        fetchingState.LOADED,
      );
      newState = newState.setIn(
        ['propertyList', 'totalCount'],
        action.data && action.data.totalProperty
          ? action.data.totalProperty.propCount
          : 0,
      );
      return newState.setIn(
        ['propertyList', 'data'],
        fromJS(action.data ? action.data.results : null),
      );
    case actions.PROPERTY_SEARCH_ERROR:
      return state.setIn(['propertyList', 'state'], fetchingState.ERROR);

    case actions.ALL_PROPERTY_FETCH_START:
      return state.set(['allPropertyFetchState'], fetchingState.FETCHING);
    case actions.ALL_PROPERTY_FETCH_SUCCESS:
      return state.set(['allPropertyFetchState'], fetchingState.LOADED);
    case actions.ALL_PROPERTY_FETCH_ERROR:
      return state.set(['allPropertyFetchState'], fetchingState.ERROR);

    case actions.PROPERTY_FETCH_START:
      return state.setIn(
        ['property', action.propertyId, 'state'],
        fetchingState.FETCHING,
      );
    case actions.PROPERTY_FETCH_SUCCESS: {
      return state
        .setIn(['property', action.propertyId, 'state'], fetchingState.LOADED)
        .setIn(
          ['property', action.propertyId, 'data'],
          action.data ? fromJS(action.data.results[0]) : null,
        );
    }
    case actions.PROPERTY_FETCH_ERROR:
      return state.setIn(
        ['property', action.propertyId, 'state'],
        fetchingState.ERROR,
      );

    case actions.PROPERTY_CHANGE_CURRENT_PAGE:
      return state.setIn(['propertyList', 'currentPage'], action.data);
    case actions.PROPERTY_CHANGE_PAGE_SIZE:
      return state.setIn(['propertyList', 'pageSize'], action.data);
    case actions.PROPERTY_CHANGE_SORT_MODEL:
      return state.setIn(['propertyList', 'sortModel'], fromJS(action.data));
    case actions.PROPERTY_CHANGE_FILTER_MODEL:
      return state.setIn(['propertyList', 'filterModel'], fromJS(action.data));

    case actions.PROPERTY_SET_SEARCH_RULE:
      return state.setIn(
        ['searchRule', action.data.ruleName],
        action.data.ruleValue,
      );
    case actions.PROPERTY_CHANGE_SEARCH_FIELD:
      return state.set('searchField', action.data);
    case actions.PROPERTY_CHANGE_SEARCH_OPERATOR:
      return state.set('searchOperator', action.data);
    case actions.PROPERTY_REMOVE_SEARCH_RULE:
      return state.setIn(['searchRule', action.data.ruleName], undefined);
    case actions.PROPERTY_REMOVE_ALL_SEARCH_RULE:
      return state.setIn(['searchRule'], fromJS({}));

    case actions.PROPERTY_COMP_GRID_FETCH_START:
      return state.setIn(['compGrid', 'state'], fetchingState.FETCHING);
    case actions.PROPERTY_COMP_GRID_FETCH_SUCCESS:
      newState = state.setIn(['compGrid', 'state'], fetchingState.LOADED);
      return newState.setIn(['compGrid', 'data'], fromJS(action.data.results));
    case actions.PROPERTY_COMP_GRID_FETCH_ERROR:
      return state.setIn(['compGrid', 'state'], fetchingState.ERROR);

    case actions.PROPERTY_CATEGORIES_FETCH_START:
      return state.setIn(
        ['propertyCategories', 'state'],
        fetchingState.FETCHING,
      );
    case actions.PROPERTY_CATEGORIES_FETCH_SUCCESS:
      newState = state.setIn(
        ['propertyCategories', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['propertyCategories', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.PROPERTY_CATEGORIES_FETCH_ERROR:
      return state.setIn(['propertyCategories', 'state'], fetchingState.ERROR);

    case actions.PROPERTY_CATEGORY_FETCH_START:
      return state.setIn(['propertyCategory', 'state'], fetchingState.FETCHING);
    case actions.PROPERTY_CATEGORY_FETCH_SUCCESS:
      newState = state.setIn(
        ['propertyCategory', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['propertyCategory', 'data'],
        fromJS({
          ...action.data.results,
          propertyId: action.propertyId,
          year: action.year,
        }),
      );
    case actions.PROPERTY_CATEGORY_FETCH_ERROR:
      return state.setIn(['propertyCategory', 'state'], fetchingState.ERROR);

    case actions.PROPERTY_COMP_SEARCH_START:
      return state.setIn(['compPropertyList', 'state'], fetchingState.FETCHING);
    case actions.PROPERTY_COMP_SEARCH_SUCCESS:
      newState = state.setIn(
        ['compPropertyList', 'state'],
        fetchingState.LOADED,
      );
      newState = newState.setIn(
        ['compPropertyList', 'totalCount'],
        action.data && action.data.totalProperty
          ? action.data.totalProperty
          : 0,
      );
      return newState.setIn(
        ['compPropertyList', 'data'],
        fromJS(action.data && action.data ? action.data.results : []),
      );
    case actions.PROPERTY_COMP_SEARCH_ERROR:
      return state.setIn(['compPropertyList', 'state'], fetchingState.ERROR);

    case actions.PROPERTY_COMP_VALID_CHECK_START:
      return state.setIn(['valid', 'state'], fetchingState.FETCHING);
    case actions.PROPERTY_COMP_VALID_CHECK_SUCCESS:
      newState = state.setIn(['valid', 'state'], fetchingState.LOADED);
      return newState.setIn(['valid', 'data'], fromJS(action.data.results));
    case actions.PROPERTY_COMP_VALID_CHECK_ERROR:
      return state.setIn(['valid', 'state'], fetchingState.ERROR);

    case actions.PROPERTY_COMP_PDF_GENERATE_START:
      return state.set('generatingComp', fetchingState.FETCHING);
    case actions.PROPERTY_COMP_PDF_GENERATE_SUCCESS:
      return state.set('generatingComp', fetchingState.LOADED);
    case actions.PROPERTY_COMP_PDF_GENERATE_ERROR:
      return state.set('generatingComp', fetchingState.ERROR);

    case actions.PROPERTY_COVER_PDF_GENERATE_START:
      return state.set('generatingCover', fetchingState.FETCHING);
    case actions.PROPERTY_COVER_PDF_GENERATE_SUCCESS:
      return state.set('generatingCover', fetchingState.LOADED);
    case actions.PROPERTY_COVER_PDF_GENERATE_ERROR:
      return state.set('generatingCover', fetchingState.ERROR);

    case actions.PROTEST_FETCH_START:
      return state.setIn(['protest', 'state'], fetchingState.FETCHING);
    case actions.PROTEST_FETCH_SUCCESS:
      newState = state.setIn(['protest', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['protest', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.PROTEST_FETCH_ERROR:
      return state.setIn(['protest', 'state'], fetchingState.ERROR);

    case actions.PROPERTY_SCORE_FETCH_START:
      return state.setIn(['score', 'state'], fetchingState.FETCHING);
    case actions.PROPERTY_SCORE_FETCH_SUCCESS:
      newState = state.setIn(['score', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['score', 'data'],
        fromJS({
          ...action.data.results,
          propertyId: action.propertyId,
          versionId: action.versionId,
          gridType: action.gridType,
        }),
      );
    case actions.PROPERTY_SCORE_FETCH_ERROR:
      return state.setIn(['score', 'state'], fetchingState.ERROR);

    case actions.INTEGRITY_CHECK_SUCCESS: {
      return state.setIn(
        ['integrityCheckData'],
        fromJS(_.get(action, 'data.results', {})),
      );
    }

    case actions.GENERATE_GOOGLE_MAP_START: {
      return state.setIn(['generatingComp'], fetchingState.FETCHING);
    }
    case actions.GENERATE_GOOGLE_MAP_SUCCESS: {
      return state.setIn(['generatingComp'], fetchingState.LOADED);
    }

    case actions.GENERATE_BING_MAP_START: {
      return state.setIn(['generatingComp'], fetchingState.FETCHING);
    }
    case actions.GENERATE_BING_MAP_SUCCESS: {
      return state.setIn(['generatingComp'], fetchingState.LOADED);
    }

    case actions.PROPERTY_SCORE_UNSET:
      return state.set('score', fromJS({}));

    default:
      return state;
  }
};
